export const providerActions = {

  FETCH_PROVIDER_FAILED: 'FETCH_PROVIDER_FAILED',
  FETCH_PROVIDER_SUCCESS: 'FETCH_PROVIDER_SUCCESS',
  FETCH_PROVIDER_PENDING: 'FETCH_PROVIDER_PENDING',
  LOAD_PROVIDER: 'LOAD_PROVIDER',


  fetchProviderFailed: error => ({
    type: providerActions.FETCH_PROVIDER_FAILED,
    payload: error
  }),

  fetchProviderSuccess: (user, {data, version}) => ({
    type: providerActions.FETCH_PROVIDER_SUCCESS,
    payload: {
      data,
      user,
      version
    }
  }),

  fetchProviderPending: user => ({
    type: providerActions.FETCH_PROVIDER_PENDING,
    payload: {
      user
    }
  }),

  loadProvider: user => ({
    type: providerActions.LOAD_PROVIDER,
    payload: {
      user: user
    }
  }),
};


export const providerRequestActions = {
  failed: providerActions.fetchProviderFailed,
  success: providerActions.fetchProviderSuccess,
  pending: providerActions.fetchProviderPending
};
